var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.steps
    ? _c("TagStatus", {
        attrs: { id: _vm.step, label: _vm.steps[_vm.step].label }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }